import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  type PutOrganisationsBoardsQueueRequestType,
  type PutOrganisationsBoardsQueueResponseType,
  putOrganisationsBoardsQueue,
} from '../../api';

import type { Node } from '../../model';
import { convertNodesToDefaultQueue } from '../helpers';
import { queryKey } from './query-key';

export type usePutOrganisationsBoardsQueueParams = Pick<
  PutOrganisationsBoardsQueueRequestType,
  'organisationId' | 'boardId'
>;

export const usePutOrganisationsBoardsQueue = (
  params: usePutOrganisationsBoardsQueueParams,
) => {
  const queryClient = useQueryClient();
  const handleSuccess = (data: PutOrganisationsBoardsQueueResponseType) => {
    queryClient.setQueryData(
      queryKey.organisationBoardsQueue(params.organisationId, params.boardId),
      data,
    );
  };

  return useMutation({
    mutationFn: async (nodes: Node[]) =>
      putOrganisationsBoardsQueue({
        organisationId: params.organisationId,
        boardId: params.boardId,
        queue: convertNodesToDefaultQueue(nodes),
      }),
    onSuccess: handleSuccess,
  });
};
